export default "__VITE_PUBLIC_ASSET__23622d26__"